import { render, staticRenderFns } from "./WebOfficialSupport.vue?vue&type=template&id=6535756d&scoped=true&"
import script from "./WebOfficialSupport.vue?vue&type=script&lang=js&"
export * from "./WebOfficialSupport.vue?vue&type=script&lang=js&"
import style0 from "./WebOfficialSupport.vue?vue&type=style&index=0&id=6535756d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6535756d",
  null
  
)

export default component.exports